/**
 * 課金商品。**メニューを増やさない**（マネタイズ・PRロードマップ M3）。
 *
 * 値段はストアに登録した値が正。ここの `fallbackPrice` はテスト用モックでだけ表示する。
 * 本番の表示は、ストアから取った現地通貨の値段に差し替わる。
 */

export type ProductId = 'ad_free' | 'items_5' | 'items_20';

export interface ProductDefinition {
  id: ProductId;
  /** ストアに登録する商品ID（App Store / Google Play 共通にする）。 */
  storeId: string;
  kind: 'non-consumable' | 'consumable';
  title: string;
  description: string;
  fallbackPrice: string;
  /** consumable のとき、増えるおはしの本数。 */
  items?: number;
}

export const PRODUCTS: Readonly<Record<ProductId, ProductDefinition>> = {
  ad_free: {
    id: 'ad_free',
    storeId: 'jp.gotochi_meshi_merge.ad_free',
    kind: 'non-consumable',
    title: '買い切り（広告なし）',
    description:
      '毎日おはしが1本届き、買い切りだけの器「朱の漆椀」が使えます。ゲームの合間の広告も出なくなります。見たいときだけのごほうび広告（コンティニュー・おはし）は残ります。',
    fallbackPrice: '¥600',
  },
  items_5: {
    id: 'items_5',
    storeId: 'jp.gotochi_meshi_merge.items_5',
    kind: 'consumable',
    title: 'おはし 5本',
    description: '料理を1つつまんで消せます（1プレイ3本まで）。',
    fallbackPrice: '¥160',
    items: 5,
  },
  items_20: {
    id: 'items_20',
    storeId: 'jp.gotochi_meshi_merge.items_20',
    kind: 'consumable',
    title: 'おはし 20本',
    description: '1本あたり24円。5本パック（1本32円）よりお得です。',
    fallbackPrice: '¥480',
    items: 20,
  },
};
